import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Slide,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import {TransitionProps} from '@material-ui/core/transitions/transition';
import React, {useEffect, useRef, useState} from 'react';
import * as yup from 'yup';
import {Formik, FormikProps} from 'formik';
import Loading from "../../UiComponents/Loading";
import PlayerPair from "../../../Domain/Models/PlayerPair";
import ScoreCard from "../../../Domain/Models/ScoreCard";
import {gameService} from "../../../Domain/Services/GameService";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  form: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  dialog: {
    alignItems: 'flex-start',
  },
  deleteFlex: {
    flex: 1,
  }
}));

export interface ScoreCardModalProps
{
  open: boolean;
  onClose: () => void;
  scoreCard: ScoreCard;
  playerPair: PlayerPair;
}

export default function ScoreCardModal(props: ScoreCardModalProps)
{
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const {open, onClose, scoreCard, playerPair} = props;
  const classes = useStyles();

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string>();

  const formRef = useRef<FormikProps<ScoreCard>>(null);

  const schema = yup.object().shape({
  });

  const handleSubmit = (value: ScoreCard) =>
  {
    setSubmitting(true);
    setSubmitError(undefined);

    gameService.updateScoreCard(playerPair, value)
        .then(() => onClose())
        .catch((e: Error) =>
        {
          setSubmitting(false);
          setSubmitError(e.message);
        });
  }

  useEffect(() =>
  {
    if (open)
    {
      setSubmitError(undefined);
      setSubmitting(false);
    }
  }, [open]);

  return (
      <Dialog
          classes={{scrollPaper: classes.dialog}}
          open={open}
          onClose={onClose}
          fullScreen={fullScreen}
          fullWidth
          maxWidth="md"
          disableEscapeKeyDown
          disableBackdropClick={submitting}
          TransitionComponent={Transition}
      >
        <DialogTitle>ScoreCard</DialogTitle>

        <Loading isLoading={submitting}>
          <DialogContent>
            <Formik<ScoreCard>
                initialValues={scoreCard}
                onSubmit={(value) => handleSubmit(value)}
                validationSchema={schema}
                innerRef={formRef}
            >
              {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur
                }) => (
                  <>
                    <FormControl fullWidth margin="normal">
                      <InputLabel>Lives Remaining</InputLabel>
                      <Input
                        name="livesRemaining"
                        type="number"
                        value={values.livesRemaining}
                        onChange={handleChange}
                        onBlur={handleBlur}/>
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                      <InputLabel>Completed</InputLabel>
                      <Checkbox
                        name="completed"
                        checked={values.completed}
                        onChange={handleChange}
                      />
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                      <InputLabel>Simplify Used</InputLabel>
                      <Checkbox
                        name="simplifyUsed"
                        checked={values.simplifyUsed}
                        onChange={handleChange}
                      />
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                      <InputLabel>Swap Used</InputLabel>
                      <Checkbox
                        name="swapUsed"
                        checked={values.swapUsed}
                        onChange={handleChange}
                      />
                    </FormControl>
                  </>
              )}
            </Formik>

            {submitError != undefined && (
                <Typography component="h3" variant="subtitle1" color="error" gutterBottom>
                  {submitError}
                </Typography>
            )}
          </DialogContent>

          <DialogActions>
            <Button
                onClick={onClose} color="primary"
            >
              Cancel
            </Button>
            <Button
                onClick={() => formRef.current?.handleSubmit()}
                color="primary"
            >
              Submit
            </Button>
          </DialogActions>

        </Loading>
      </Dialog>
  );
}